module.exports = __webpack_public_path__ + "img/bgc12.b2cc4b5e.png";